<template>
  <material-card color="dover-blue">
    <div>
      <v-flex
        xs12
        md12>
        <material-card
          :title="`${$t('Inventory')}`"
          data-testId="material-card-Tank-inventory"
          color="dover-blue">
          <div>
            <v-flex
              xs12
              md12>
              <v-tabs
                data-testId="tabs"
                fixed-tabs
                color="dover-blue"
                slider-color="yellow"
                dark
                icons-and-text>
                <v-tab
                  :key="0"
                  data-testId="tab-history"
                  ripple>
                  {{ $t('History') }}
                </v-tab>
                <v-tab-item :key="0">
                  <MaglinkReportHistory
                    :system-settings="systemSettings"
                    :options="options"
                    :site-info="siteInfo"
                    :tanks="tanks"
                    data-testId="MaglinkReportHistory" />
                </v-tab-item>
                <v-tab
                  :key="1"
                  data-testId="tab-current"
                  ripple>
                  {{ $t('Current') }}
                </v-tab>
                <v-tab-item :key="1">
                  <MaglinkReportInventory
                    :system-settings="systemSettings"
                    :options="options"
                    :site-info="siteInfo"
                    :tanks="tanks"
                    data-testId="MaglinkReportInventory" />
                </v-tab-item>
              </v-tabs>
            </v-flex>
          </div>
        </material-card>
      </v-flex>
    </div>
  </material-card>
</template>

<script>
export default {
  props: {
    tanks: {
      type: Array,
      required: true,
      default: () => []
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => { }
    },
    options: {
      type: Object,
      required: true,
      default: () => { }
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => { }
    }
  },
  mounted () {

  }
}
</script>
